// COM-HUBS (2026-08-21): Comissões & Indicações.
//
// ⚠️ Hub de audiência LARGA, diferente dos outros quatro. Comissões e
// Indicações (REMVAR) são de TODO MUNDO — engenheiro, topógrafo, coordenador —
// não só de quem usa CRM. Por isso o item do menu fica em G_ADMINISTRATIVO_VIEW
// e as duas páginas nunca podem ser enfiadas num hub gateado ao grupo comercial:
// quem não é do comercial perderia a própria comissão de vista.
import HubAbas, { HubTab } from '../../components/HubAbas';
import ComissoesAcompanhamento from '../ComissoesAcompanhamento';
import ComercialIndicacoes from '../ComercialIndicacoes';

const TABS: HubTab[] = [
  { key: 'comissoes',  label: '💼 Comissões',  perm: 'comercial.comissoes.ver',    render: () => <ComissoesAcompanhamento /> },
  { key: 'indicacoes', label: '🤝 Indicações', perm: 'comercial.indicacoes.criar', render: () => <ComercialIndicacoes /> },
];

export default function ComercialComissoesHub() {
  return <HubAbas tabs={TABS} />;
}
